import { render } from "./CheckedPickup.vue?vue&type=template&id=2b294a50"
import script from "./CheckedPickup.vue?vue&type=script&lang=js"
export * from "./CheckedPickup.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__